import React, { useEffect, useState, useRef } from "react";
import UserGroupList from "../component/groups/userGroupList";
import { useDispatch, useSelector } from "react-redux";
import * as userAction from "../../../redux/actions/userAction";
import {
  API_STATUS,
  HBNEXT_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
} from "../../../constant/constant";
import { useNavigate } from "react-router-dom";
import {
  ACCESS_DENIED,
  ADD_ADMIN_GROUP,
  ADMIN_GROUP,
} from "../../../constant/routeContant";
import { checkPrivileges, showRighSideMenu } from "../../../utils/rolesHelper";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { toast, ToastContainer } from "react-toastify";
import { getPreviousRoute } from "../../../utils/routeTracker";

const GroupsListContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const GroupListData = useSelector((state) => state.GroupListData);

  const getuserGroupLists = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(userAction.getListGroupLists(data));
    dispatch(userAction.getUserGroupsListFilterObj(data));
  };

  const deleteGroup = (userId) => {
    deleteTriggeredRef.current = true;
    dispatch(userAction.deleteUserGroup(userId));
  };

  const divisiondata = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons
  );

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: "6",
    productId: PRODUCT_ID(),
  };
  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  const deleteUserGroupData = useSelector(
    (state) => state?.deleteUserGroupData
  );
  const loading = GroupListData.isLoading || deleteUserGroupData.isLoading;
  useEffect(() => {
    if (deleteUserGroupData?.status === "SUCCESS" && deleteTriggeredRef.current) {
      deleteTriggeredRef.current = false;
      const defaultData = {
        page: 1,
        pageSize: PAGE_SIZE,
        search: "",
        divisionId: 0,
        allGroups: true,
        isSendMail: false,
      };
      const currentFilter = GroupListData?.filterObjs || defaultData;
      getuserGroupLists(currentFilter);
    }
  }, [deleteUserGroupData]);

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADD_ADMIN_GROUP];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("groupListPreserveState") === "true";
    sessionStorage.removeItem("groupListPreserveState");

    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      divisionId: 0,
      allGroups: true,
      orgId: ORG_ID(),
      isSendMail: false,
    };

    if (isFromPreserveRoute && GroupListData?.filterObjs) {
      setShouldRestoreState(true);
      getuserGroupLists(GroupListData.filterObjs);
    } else {
      setShouldRestoreState(false);
      getuserGroupLists(data);
    }
  }, []);

  useEffect(() => {
    if (GroupListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Groups has been sent to registered email ID");
    }
  }, [GroupListData]);

  const showMenu = showRighSideMenu();
  const groupAccessSW =
    showMenu?.isSW &&
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
    checkPrivileges([12, 55, 56]);
  const groupAccessSafety = showMenu?.isSafety && checkPrivileges([12, 55, 56]);


  return (
    <>
      {groupAccessSW || groupAccessSafety ? (
        <>
          <ToastContainer />
          <UserGroupList
            GroupListData={GroupListData?.data?.result?.groupData}
            noOfRecords={GroupListData?.data?.result?.noOfRecords}
            getuserGroupLists={getuserGroupLists}
            loading={loading}
            deleteGroup={deleteGroup}
            divisiondata={divisiondata}
            GroupListDatas={GroupListData}
            isShowDowdownloadButton={true}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};
export default GroupsListContainer;
